/*common*/
import AllService from "../assets/all_service.svg";

/*Male icons*/
import HairCare from "../assets/haircare.svg";
import SkinCare from "../assets/skincare.svg";
import BodyCare from "../assets/bodycare.svg";
import MakeUp from "../assets/makeup.svg";
import MassgeSpa from "../assets/massage_spa.svg";
import Shave from "../assets/shave.svg";
import Packages from "../assets/packages.svg";
import HomeService from "../assets/home_service.svg";
import Other from "../assets/packages.svg";

/*Female icons*/
import FeMaleHairCare from "../assets/haircare_female.svg";
import FeMaleSkinCare from "../assets/skincare_female.svg";
import FeMaleBodyCare from "../assets/bodycare_female.svg";
import FeMaleMakeUp from "../assets/makeup_female.svg";
import NailCare from "../assets/nailcare.svg";
import Waxing from "../assets/waxing.svg";

export const GENDERS = ["Male", "Female", "Unisex"];
export const GENDERS_SERVICE = ["Male", "Female"];
export const EXPENSES_TABS = ["Earnings", "Expense"];
export const BOOKINGS_TABS = ["Upcoming", "Previous"];
export const DATE_FORMAT = "DD/MM/YYYY";
export const BOOKINGS_DATE_FORMAT = "YYYY-MM-DD";

export const ALL = "All";

//routes
export const SALON_LIST_ROUTE = "/salon-list";
export const SALON_DETAILS_ROUTE = "/salon-details";
export const SALON_CHECKOUT_ROUTE = "/salon-checkout";
export const OTP_SIGN_IN = "/otp-signin";
export const MY_BOOKINGS = "/my-bookings";
export const MY_BOOKINGS_SALON = "/my-appointments-salon";
export const SALON_ONBOARDING = "/salon-onboarding";
export const VIEW_SERVICES = "/view-service";
export const ADD_SERVICE = "/add-service";
export const USER_HOME = "/user-home";
export const EDIT_SERVICE = "/edit-service";
export const SALON_HOME = "/salon-home";
export const FEEDBACK = "/feedback";
export const ANALYTICS = "/analytics";
export const REFERAL = "/referal";
export const ADD_EXPENSES = "/add-expenses";
export const VIEW_EXPENSES = "/view-expenses";
export const EDIT_EXPENSE = "/edit-expense";
export const TERMS_CONDITION = "/tnc";
export const PRIVACY_POLICY = "/privacy-policy";
export const NOTIFICATIONS = "/notifications";
export const SIDEMENU = "/sidemenu";
export const OTP_LOGIN = "/otp-login";
export const USER_ADDRESS = "/user-address";
export const USER_ADDRESS_LIST = "/user-address-list";
export const PROMO = "/promo-codes";
export const VIEW_PROMO = "/view-promo-codes";
export const EDIT_PROMO = "/edit-promo-codes";
export const TRY_ON = "/try-on";
export const VIEW_BILL = "/view-bill";

export const SALON_NAVIGAION = {
  home: SALON_HOME,
  myBookings: MY_BOOKINGS_SALON,
  notifications: "",
  invite: REFERAL,
  update: `${SALON_ONBOARDING}/details`,
  salon: "",
  tnc: TERMS_CONDITION,
  privacy: PRIVACY_POLICY,
  contact: FEEDBACK,
  logout: "",
  sideMenu: SIDEMENU,
  promo: PROMO,
  viewPromo: VIEW_PROMO,
  editPromo: EDIT_PROMO,
  tryOn: TRY_ON,
  email: TRY_ON,
};

export const USER_NAVIGARION = {
  home: USER_HOME,
  myBookings: MY_BOOKINGS,
  notifications: "",
  invite: REFERAL,
  update: "",
  salon: `${SALON_ONBOARDING}/details`,
  tnc: TERMS_CONDITION,
  privacy: PRIVACY_POLICY,
  contact: FEEDBACK,
  logout: "",
  sideMenu: SIDEMENU,
};

export const STATE_UT = [
  { code: "AN", name: "Andaman and Nicobar Islands" },
  { code: "AP", name: "Andhra Pradesh" },
  { code: "AR", name: "Arunachal Pradesh" },
  { code: "AS", name: "Assam" },
  { code: "BR", name: "Bihar" },
  { code: "CG", name: "Chandigarh" },
  { code: "CH", name: "Chhattisgarh" },
  { code: "DH", name: "Dadra and Nagar Haveli" },
  { code: "DD", name: "Daman and Diu" },
  { code: "DL", name: "Delhi" },
  { code: "GA", name: "Goa" },
  { code: "GJ", name: "Gujarat" },
  { code: "HR", name: "Haryana" },
  { code: "HP", name: "Himachal Pradesh" },
  { code: "JK", name: "Jammu and Kashmir" },
  { code: "JH", name: "Jharkhand" },
  { code: "KA", name: "Karnataka" },
  { code: "KL", name: "Kerala" },
  { code: "LD", name: "Lakshadweep" },
  { code: "MP", name: "Madhya Pradesh" },
  { code: "MH", name: "Maharashtra" },
  { code: "MN", name: "Manipur" },
  { code: "ML", name: "Meghalaya" },
  { code: "MZ", name: "Mizoram" },
  { code: "NL", name: "Nagaland" },
  { code: "OR", name: "Odisha" },
  { code: "PY", name: "Puducherry" },
  { code: "PB", name: "Punjab" },
  { code: "RJ", name: "Rajasthan" },
  { code: "SK", name: "Sikkim" },
  { code: "TN", name: "Tamil Nadu" },
  { code: "TS", name: "Telangana" },
  { code: "TR", name: "Tripura" },
  { code: "UK", name: "Uttarakhand" },
  { code: "UP", name: "Uttar Pradesh" },
  { code: "WB", name: "West Bengal" },
];

export const MALE_HOME_ICONS = {
  all: AllService,
  HairCare: HairCare,
  MakeUp: MakeUp,
  Waxing: Waxing,
  SkinCare: SkinCare,
  BodyCare: BodyCare,
  NailCare: NailCare,
  MassgeSpa: MassgeSpa,
  Shave: Shave,
  Other: Other,
  Packages: Packages,
  HomeService: HomeService,
};

export const FEMALE_HOME_ICONS = {
  all: AllService,
  FeMaleHairCare: FeMaleHairCare,
  Waxing: Waxing,
  FeMaleSkinCare: FeMaleSkinCare,
  FeMaleMakeUp: FeMaleMakeUp,
  FeMaleBodyCare: FeMaleBodyCare,
  MassgeSpa: MassgeSpa,
  NailCare: NailCare,
  Packages: Packages,
  Other: Other,
  HomeService: HomeService,
};

export const CHART_OPTIONS = {
  userRatings: {
    title: "User Ratings",
    titleTextStyle: {
      fontSize: 20,
      color: "#4A4A4A",
      marginBottom: 20,
      bold: false,
      textAlign: "center",
    },
    hAxis: {
      title: "Users",
      minValue: 0,
    },
    vAxis: {
      title: "Ratings",
    },
    legend: "bottom",
  },
  soldServices: {
    title: "Sold Service Count",
    titleTextStyle: {
      fontSize: 20,
      color: "#4A4A4A",
      paddingBottom: 20,
      bold: false,
      height: 120,
    },
    hAxis: {
      title: "Users",
      minValue: 0,
    },
    vAxis: {
      title: "Ratings",
    },
  },
  serviceRevenue: {
    title: "Services Revenue",
    titleTextStyle: {
      fontSize: 20,
      color: "#4A4A4A",
      marginBottom: 20,
      bold: false,
      textAlign: "center",
    },
    hAxis: {
      title: "Revenue",
      minValue: 0,
    },
    bar: { groupWidth: "30%" },
    vAxis: {
      title: "Services",
    },
    legend: "bottom",
  },
};

export const EXPENSE_MAPPER = {
  Earnings: "Credit",
  Expense: "Debit",
};

export const EXPENSE_MAPPER_REVERSE = {
  Credit: "Earnings",
  Debit: "Expense",
};

export const EXPENSE_MAPPER_VIEW = {
  Credit: "Earnings",
  Debit: "Expense",
};

export const TIME_DURATION = 60000;

export const DAY_DROPDOWN = [
  {
    code: "AM",
    name: "AM",
  },
  {
    code: "PM",
    name: "PM",
  },
];

export const API_GENDER_TO_FILTER_GENDER = {
  male: "Male",
  female: "Female",
  unisex: "Unisex",
};

export const REFERAL_AMOUNT = 50;

export const HAIR_STYLES = [
  "https://res.cloudinary.com/dtqu6jj56/image/upload/v1745332731/aieaseExample_aiHairStyle_1_rc12ur.webp",
  "https://pub-static.aiease.ai/aieaseExample%2FaiHairStyle%2F2.webp",
  "https://pub-static.aiease.ai/aieaseExample%2FaiHairStyle%2F3.webp",
  "https://pub-static.aiease.ai/aieaseExample%2FaiHairStyle%2F4.webp",
  "https://pub-static.aiease.ai/aieaseExample%2FaiHairStyle%2F5.webp",
  "https://pub-static.aiease.ai/aieaseExample%2FaiHairStyle%2F6.webp",
  "https://pub-static.aiease.ai/aieaseExample%2FaiHairStyle%2F7.webp",
  "https://pub-static.aiease.ai/aieaseExample%2FaiHairStyle%2F8.webp",
  "https://pub-static.aiease.ai/aieaseExample%2FaiHairStyle%2F9.webp",
  "https://pub-static.aiease.ai/aieaseExample%2FaiHairStyle%2F10.webp",
  "https://pub-static.aiease.ai/aieaseExample%2FaiHairStyle%2F11.webp",
  "https://pub-static.aiease.ai/aieaseExample%2FaiHairStyle%2F12.webp",
  "https://pub-static.aiease.ai/aieaseExample%2FaiHairStyle%2F13.webp",
  "https://pub-static.aiease.ai/aieaseExample%2FaiHairStyle%2F14.webp",
  "https://pub-static.aiease.ai/aieaseExample%2FaiHairStyle%2F28.webp",
  "https://pub-static.aiease.ai/aieaseExample%2FaiHairStyle%2F15.webp",
  "https://pub-static.aiease.ai/aieaseExample%2FaiHairStyle%2F16.webp",
  "https://pub-static.aiease.ai/aieaseExample%2FaiHairStyle%2F17.webp",
  "https://pub-static.aiease.ai/aieaseExample%2FaiHairStyle%2F18.webp",
  "https://pub-static.aiease.ai/aieaseExample%2FaiHairStyle%2F19.webp",
  "https://pub-static.aiease.ai/aieaseExample%2FaiHairStyle%2F20.webp",
  "https://pub-static.aiease.ai/aieaseExample%2FaiHairStyle%2F21.webp",
  "https://pub-static.aiease.ai/aieaseExample%2FaiHairStyle%2F22.webp",
  "https://pub-static.aiease.ai/aieaseExample%2FaiHairStyle%2F25.webp",
  "https://pub-static.aiease.ai/aieaseExample%2FaiHairStyle%2F23.webp",
  "https://pub-static.aiease.ai/aieaseExample%2FaiHairStyle%2F26.webp",
];

export const HAIR_COLORS = [
  "https://res.cloudinary.com/dtqu6jj56/image/upload/v1745576841/hair_color_variant_1_xmfunu.png",
  "https://res.cloudinary.com/dtqu6jj56/image/upload/v1745576879/hair_color_variant_2_l0pcma.png",
  "https://res.cloudinary.com/dtqu6jj56/image/upload/v1745576909/hair_color_variant_3_kxeege.png",
  "https://res.cloudinary.com/dtqu6jj56/image/upload/v1745576940/hair_color_variant_4_de4g1f.png",
];
